import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

// The ML certainty score is in [50, 100]. Per design, 80-100 renders the green chip,
// anything below the neutral one.
export const ConfidenceChip = ({ value }) => {
    if (value == null) return null;
    return (
        <div
            className={cn(
                "flex h-5 shrink-0 items-center rounded px-2 text-xs font-medium",
                value >= 80
                    ? "bg-cm-p-container-green text-cm-p-on-container-green"
                    : "bg-cm-p-surface-container text-cm-p-text-primary",
            )}
        >
            <TranslatedText>Confidence level</TranslatedText>
            <span className="ml-1">{value}</span>
        </div>
    );
};
